export default __webpack_public_path__ + "static/media/marketing_campain_banner.4b5d34e1.png";